// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2530": "e96a97f91d26","4362": "8e0011f4cb55","5342": "e2f2bf30067c","5707": "69992d49bf8b","6863": "454c9f289029","8270": "72223c79a1b1",}[chunkId] + ".css"
}